import * as React from 'react';
import { memo } from 'react';
import Accordion from '../../../../components/Accordion/Accordion';
import { eventTracker } from '../../../../helpers/EventTracker/EventTracker';
import { __ } from '../../../../helpers/TranslationService';
import { useTypedSelector } from '../../../../hooks/useTypedSelector';
import { ICabinInfo } from '../../../../interfaces';

const sendEventTrack = (title: string) => {
    eventTracker.track({
        category: title,
        action: 'cruisepage-infobox',
        label: title,
    });
};

const Cabins = () => {
    const { cruisePage } = useTypedSelector((state) => state);
    const { title } = cruisePage;
    const cabins =
        cruisePage.cabins !== null && cruisePage.cabins.length > 0
            ? cruisePage.cabins
            : [
                  ...cruisePage.processedCabins.inside.cabins,
                  ...cruisePage.processedCabins.balcony.cabins,
                  ...cruisePage.processedCabins.outside.cabins,
                  ...cruisePage.processedCabins.outside.cabins,
              ];
    return (
        <Accordion
            firstTabOpenByDefault
            onHeaderClick={() => sendEventTrack(title)}
            items={
                cabins
                    ?.sort((a, b) => {
                        return a.cabinType.kindId - b.cabinType.kindId;
                    })
                    .map((item) => ({
                        title: item.cabinType.title,
                        content: (
                            <div className="cabin-description">
                                {!!item?.cabinType?.image?.original && (
                                    <img
                                        alt={item?.cabinType?.title}
                                        className="cabin-description__image"
                                        src={item.cabinType.image.original}
                                    />
                                )}
                                {!!item?.cabinType?.location && (
                                    <p className="cabin-description__item">
                                        <span className="cabin-description__title">
                                            {__('Location', 'dreamlines')}
                                        </span>
                                        {`: ${item.cabinType.location}`}
                                    </p>
                                )}
                                {!!item?.cabinType?.size && (
                                    <p className="cabin-description__item">
                                        <span className="cabin-description__title">
                                            {__('Cabin size', 'dreamlines')}
                                        </span>
                                        {`: ${item.cabinType.size}`}
                                    </p>
                                )}
                                {!!item?.cabinType?.maxPassengers && (
                                    <p className="cabin-description__item">
                                        <span className="cabin-description__title">
                                            {__('Occupancy', 'dreamlines')}
                                        </span>
                                        {`: ${item.cabinType.maxPassengers}`}
                                    </p>
                                )}
                                {!!item?.cabinType?.amenities.length && (
                                    <>
                                        <p className="cabin-description__item">
                                            <span className="cabin-description__title">
                                                {__('Amenities', 'dreamlines')}
                                            </span>
                                            :
                                        </p>
                                        <ul className="cabin-description__list">
                                            {item.cabinType.amenities.map((el) => (
                                                <li
                                                    className="cabin-description__list__item"
                                                    key={el}
                                                >
                                                    {el}
                                                </li>
                                            ))}
                                        </ul>
                                    </>
                                )}
                                {!!item?.cabinType?.advantages.length && (
                                    <>
                                        <p className="cabin-description__item">
                                            <span className="cabin-description__title">
                                                {__(
                                                    'Following advantages are included',
                                                    'dreamlines',
                                                )}
                                            </span>
                                            :
                                        </p>
                                        <ul className="cabin-description__list">
                                            {item.cabinType.advantages.map((el) => (
                                                <li
                                                    className="cabin-description__list__item"
                                                    key={el}
                                                >
                                                    {el}
                                                </li>
                                            ))}
                                        </ul>
                                    </>
                                )}
                            </div>
                        ),
                    })) || []
            }
        />
    );
};

export default memo(Cabins);
